import { useEffect, DependencyList, useCallback } from "react";

import firebase from "firebaseFactory";
import { FirebaseShard } from "firebaseWrapper";

export interface FirebaseSubscriptionCallback<T> {
  (key: string | null, data: T): void;
}
export function useFirebaseSubscription<T>(
  shard: FirebaseShard,
  key: string,
  listenerType: firebase.database.EventType,
  callback: FirebaseSubscriptionCallback<T>,
  deps: DependencyList
) {
  const loadDataCallback = useCallback(callback, deps);
  useEffect(() => {
    const ref = firebase.database(shard).ref(key);
    const listener = ref.on(listenerType, (dataSnapshot) => {
      loadDataCallback(dataSnapshot.key, dataSnapshot.val());
    });
    return () => ref.off(listenerType, listener);
  }, [loadDataCallback, listenerType, key, shard]);
}
